import {getCurrentLayout} from "../../../appLayout";
import {getGroupDescription} from "../../../selectionWindow/selectionDescriptionCoverTranslates";
import {CART_ITEM_ADDED_BY} from "../../../shoppingCart/cartItemInterface";
import {cartItemInStock, getDbFeatureProperty} from "../../lookNavigation/lookFunctions2";
import {IS_LIXIL_SERVERS, IS_PRODUCT_JOURNEY} from "../../../../config";
import {getFeatureUnit} from "../../../../misc/helpers";
import store from "../../../../store";
// import {getBvFeatures} from "../../../../api/server-api";

/**
 * Returns qtCatProperties
 * @param lookActiveFeature {object}
 * @returns {object} objects
 */
export const getAvailableWizardList = (lookActiveFeature) => {
  if (!lookActiveFeature) {
    return {}
  }
  const parent = lookActiveFeature.getParent();

  return parent.qtCatProperties ? parent.qtCatProperties : {};
}

/**
 * Returns subParts
 * @param qtCategoryName {string}
 * @returns {array} array of objects
 */
export const getWizardSubParts = (qtCategoryName) => {
  const layout = getCurrentLayout();
  if (layout.qtCategories) { // set default if index is not matching
    //console.log("qtCategories", layout.qtCategories);//virtualized list //navigation subitems

    let qtCategory = layout.qtCategories.find(qtCat => qtCat.name === qtCategoryName);
    if (qtCategory && qtCategory.subParts) {
      return qtCategory.subParts
    }
  }
  return []
}

/**
 * Returns active features list for
 * @param subPart {object}
 * @param intl {object}
 * @param fabricatorData array
 * @returns {array} array of objects
 */
export const getFeatureGroupDescription = (subPart, intl, fabricatorData) => {
  const name = (subPart.customGroupDisplayName || subPart.partName || "").toLowerCase();
  if ((fabricatorData.isLowes || fabricatorData.isCaesarStone) && intl.messages) {
    if (intl.locale === "fr-FR" && intl.messages["transDoc.description_FR." + name]) {
      return intl.formatMessage({id: "transDoc.description_FR."  + name})
    } else if (intl.locale === "pl-PL" && intl.messages["transDoc.customTranslateDescription_PL." + name]) {
      return intl.formatMessage({id: "transDoc.customTranslateDescription_PL."  + name})
    }
  }
  return subPart.customDescription || subPart.description
    || intl.formatMessage({ id: getGroupDescription(subPart.partName) });
};

// const getMissingFeatures = (missingFeatures) => {
//   getBvFeatures(missingFeatures)
//     .then(response => {
//       const layout = getCurrentLayout();
//       layout.loadNewFeatures(response.data);
//       return true
//     })
//     .catch(() => false)
// }

/**
 * returns bundled features
 * @param feature {featureInterface}
 * @returns {array}
 */
export const getLixilRequiredNotIncludedFeatures = (feature) => {
  if (Array.isArray(feature.dbFeature[getDbFeatureProperty("lixilRequiredNotIncluded")]) && feature.dbFeature[getDbFeatureProperty("lixilRequiredNotIncluded")].length) {
    // todo remove
    //feature.dbFeature[getDbFeatureProperty("lixilRequiredNotIncluded")].push(90068248, 90068237, 90068210, 90074461, 90068828, 90074449,
    // 90068281, 90068389, 90069955, 90069948, 90069950, 90071177, 90070070, 90069587 );
    // await getMissingFeatures(feature.dbFeature[getDbFeatureProperty("lixilRequiredNotIncluded")]);

    const layout = getCurrentLayout();
    let allFeatures = layout.getAllFeatures(true);
    let lixilRequiredNotIncluded = allFeatures.filter((checkFeature) => {
      return feature.dbFeature[getDbFeatureProperty("lixilRequiredNotIncluded")].includes(checkFeature.dbFeature.id)
    });
    console.log("lixilRequiredNotIncluded", lixilRequiredNotIncluded);

    return lixilRequiredNotIncluded
  }
  return []
}

/**
 * returns formatted string
 * @param str {string}
 * @returns {string}
 */
export const formatStrToUrl = (str) => {
  if (!str) {
    return ""
  }

  return str.replace(/\s+/g, '-').toLowerCase();
}


/**
 * removes check collection for specific fabricator
 * @param feature {featureInterface}
 * @returns {boolean}
 */
export const allowCheckForCollection = (feature) => {
  if (!feature) {
    return true
  }
  // For shower fixture we have same customDisplayName, but different collection name ("Euphoria" and "Shower Configuration").
  // But they still should match
  // return feature.partId !== "shower_fixture"
  return true
}

const unitsToCountQuantity = ["unit", "units", "qty", "each", "Each", "no quantity"];

/**
 * returns current cart items length (with all quantites or only cart Items)
 * @param cartItems {[cartItemInterface]}
 * @param intl {object}
 * @param forceCheckAllQuantitties {boolean}
 * @returns {number}
 */
export const getCartItemsCount = (cartItems, intl = null, forceCheckAllQuantitties = IS_LIXIL_SERVERS) => {

  const fabricatorData = store.getState().fabricatorState;

  return cartItems.reduce((total, cartItem) => {
    const shouldBeCounted = !cartItem.relatedProductParent && !cartItem.isRemoved && cartItemInStock(cartItem);
    if (!shouldBeCounted || (IS_PRODUCT_JOURNEY && cartItem.addedBy !== CART_ITEM_ADDED_BY.user)) {
      return total
    }
    // || (featureIsBundle(cartItem.cartFeature, cartItems) && getBundledFeatures(cartItem.cartFeature).some(relFeature => relFeature.dbFeature[getDbFeatureProperty("lixilAvailableQty")] > 0))
    if (forceCheckAllQuantitties) {
      return total + cartItem.quantity
    } else if (intl) {
      const unit = getFeatureUnit(cartItem.cartFeature, intl, fabricatorData, cartItem.quantity, cartItem);
      if (unit && unitsToCountQuantity.includes(unit.toLowerCase())) {
        return total + cartItem.quantity
      }
    }
    // Items in visualizer should equal total quantity of items minus out of stock (Shower bundle will count as 1 not 7)
    return total + 1  // simple return cart items count
  }, 0)
}

